import { useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';

/**
 * useClaseEnCurso — Hook global que consulta cada 60s si hay una clase en
 * curso ahora mismo (según el horario y día programado). Se usa para
 * silenciar el walkie/PTT durante clases y evitar interrumpir a estudiantes
 * y profesores.
 *
 * Devuelve: { hayClaseEnCurso, clasesActivas, loading }.
 */
export default function useClaseEnCurso(intervalMs = 60000) {
  const { API, user } = useContext(AuthContext);
  const [hayClaseEnCurso, setHayClaseEnCurso] = useState(false);
  const [clasesActivas, setClasesActivas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    if (!user) return;
    try {
      const resp = await axios.get(`${API}/system/clase-en-curso`);
      setHayClaseEnCurso(!!resp.data?.hay_clase_en_curso);
      setClasesActivas(resp.data?.clases || []);
    } catch (_e) {
      // silencioso; se reintenta en el próximo ciclo
    } finally {
      setLoading(false);
    }
  }, [API, user]);

  useEffect(() => {
    fetchStatus();
    const id = setInterval(fetchStatus, intervalMs);
    return () => clearInterval(id);
  }, [fetchStatus, intervalMs]);

  return { hayClaseEnCurso, clasesActivas, loading, refresh: fetchStatus };
}
